import React from "react";
import Navbar from "./Navbar";

const AppLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <div >{children}</div>
    </>
  );
};

export default AppLayout;
